<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="mini"
      inline-message
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_docFileType') || '文档类型'"
            prop="docFileType"
          >
            <dict-select
              v-model="formData.docFileType"
              url="/master/common/dict/biz"
              :placeholder="$l('INDEX.tips_select_data') || '请选择'"
              style="width: 100%"
              filterable
              clearable
              size="mini"
              :body="docFileTypeParams"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item :label="$l('INDEX.table_label_remarks') || '备注说明'">
            <el-input
              v-model="formData.docRemark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="mini"
              clearable
              maxlength="500"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-upload
          class="mb-4"
          action="#"
          multiple
          :file-list="listFile"
          :auto-upload="false"
          :limit="5"
          :on-exceed="onFileExceed"
          :on-change="onFileChange"
          :on-remove="onFileChange"
        >
          <el-button
            id="orderInspectionDocUploadBtn"
            slot="trigger"
            size="small"
            type="primary"
          >
            {{ $l('INDEX.order_form_btn_select_file') || '选取文件' }}
          </el-button>
        </el-upload>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {},
  props: {
    tripReimbursementCode: {type: String, default: ''},
    tripReimbursementItemCode: {type: String, default: ''},
    tripReimbursementReportCode: {type: String, default: ''},
  },
  data() {
    return {
      docFileTypeParams: {dictType: 'docFileType'},
      formData: {},
      listFile: [],
      rules: {
        docFileType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change',
          },
        ],
      },
      backDialogVisible: false,
    }
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (!this.listFile || !this.listFile.length) {
        this.$message.warning(
          this.$l('INDEX.tips_upload_file') || `请选择需要上传的文件`
        )
        return
      }

      this.loadingOpen()

      const listFile = await this.uploadFiles()

      if (!listFile || listFile.length !== listFile.filter(Boolean).length)
        return

      const params = {
        ...this.formData,
        tripReimbursementCode: this.tripReimbursementCode,
        tripReimbursementItemCode: this.tripReimbursementItemCode,
        tripReimbursementReportCode: this.tripReimbursementReportCode,
        listFile,
      }

      this.$api
        .userTripReimbursementReportDocBatchUploadApi(params)
        .then((res) => {
          this.loadingClose()
          const {status} = res
          if (status !== 200) {
            this.$message.error(
              this.$l('INDEX.table_Upload_failed') || '上传失败'
            )
            return
          }
          this.$message({
            showClose: true,
            message:
              this.$l('INDEX.uploader_message_status_success') || '上传成功',
            type: 'success',
          })
          this.$emit('reload')
          this.$emit('close')
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    onFileChange(files, fileList) {
      this.listFile = fileList
    },
    onFileExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 5 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    uploadFiles() {
      if (!this.listFile || !this.listFile.length) {
        return Promise.resolve([])
      }
      const uploadTask = this.listFile.map((file) => {
        return this.$api
          .SYS_UPLOAD(file.raw)
          .then((res) => ({
            fileCode: res.body.fileId,
            fileUrl: res.body.url,
            fileName: file.name,
          }))
          .catch(() => {
            this.loadingClose()
          })
      })
      return Promise.all(uploadTask)
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
